import { format, intlFormat } from 'date-fns';

const parseStringDate = (date: Date | string): Date => {
  if (typeof date === 'string') {
    return new Date(date);
  }
  return date;
};

export const formatDateDDMMMYYYY = (date: Date | string): string => {
  return format(parseStringDate(date), 'dd MMM yyyy').toUpperCase();
};

export const formatDateHuman = (date: Date | string, locale = 'es'): string => {
  return intlFormat(
    parseStringDate(date),
    { year: 'numeric', month: 'long', day: 'numeric' },
    { locale },
  );
};

export const formatDateDDMMYYYY = (date: Date | string): string => {
  return format(parseStringDate(date), 'dd/MM/yyyy').toUpperCase();
};

export const formatDateDDMMMHHMM = (date: Date | string): string => {
  const parsedDate = parseStringDate(date);
  const day = format(parsedDate, 'dd');
  const monthShort = parsedDate.toLocaleString('es-ES', { month: 'short' });
  const time = format(parsedDate, 'HH:mm');

  return `${day} ${monthShort}, ${time}`;
};
